module.exports = __webpack_public_path__ + "img/vertical_4_5_3009.00e39c02.png";